"use strict";

var _classCallCheck = require("/home/paul/Projects/ResoluteWeb/resoluteweb/src/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/paul/Projects/ResoluteWeb/resoluteweb/src/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Infecter = void 0;

var Infecter = /*#__PURE__*/function () {
  function Infecter(container) {
    _classCallCheck(this, Infecter);

    this.container = container;
  }

  _createClass(Infecter, [{
    key: "startInfection",
    value: function startInfection(stage) {
      var options = this.container.options;
      var stages = options.infection.stages;
      var stagesCount = stages.length;

      if (stage > stagesCount || stage < 0) {
        return;
      }

      this.infectionDelay = 0;
      this.infectionDelayStage = stage;
    }
  }, {
    key: "updateInfectionStage",
    value: function updateInfectionStage(stage) {
      var options = this.container.options;
      var stagesCount = options.infection.stages.length;

      if (stage > stagesCount || stage < 0 || this.infectionStage !== undefined && this.infectionStage > stage) {
        return;
      }

      this.infectionStage = stage;
      this.infectionTime = 0;
    }
  }, {
    key: "updateInfection",
    value: function updateInfection(delta) {
      var options = this.container.options;
      var infection = options.infection;
      var stages = options.infection.stages;
      var stagesCount = stages.length;

      if (this.infectionDelay !== undefined && this.infectionDelayStage !== undefined) {
        var stage = this.infectionDelayStage;

        if (stage > stagesCount || stage < 0) {
          return;
        }

        if (this.infectionDelay > infection.delay * 1000) {
          this.infectionStage = stage;
          this.infectionTime = 0;
          delete this.infectionDelay;
          delete this.infectionDelayStage;
        } else {
          this.infectionDelay += delta;
        }
      } else {
        delete this.infectionDelay;
        delete this.infectionDelayStage;
      }

      if (this.infectionStage !== undefined && this.infectionTime !== undefined) {
        var infectionStage = stages[this.infectionStage];

        if (infectionStage.duration !== undefined && infectionStage.duration >= 0) {
          if (this.infectionTime > infectionStage.duration * 1000) {
            this.nextInfectionStage();
          } else {
            this.infectionTime += delta;
          }
        } else {
          this.infectionTime += delta;
        }
      } else {
        delete this.infectionStage;
        delete this.infectionTime;
      }
    }
  }, {
    key: "nextInfectionStage",
    value: function nextInfectionStage() {
      var options = this.container.options;
      var stagesCount = options.infection.stages.length;

      if (stagesCount <= 0 || this.infectionStage === undefined) {
        return;
      }

      this.infectionTime = 0;

      if (stagesCount <= ++this.infectionStage) {
        if (options.infection.cure) {
          delete this.infectionStage;
          delete this.infectionTime;
          return;
        } else {
          this.infectionStage = 0;
          this.infectionTime = 0;
        }
      }
    }
  }]);

  return Infecter;
}();

exports.Infecter = Infecter;